import { getPhaseFiles } from "../../../../api/v2/FilesApi";
import { Modules } from "../../../../dtos/Modules";
import { PhaseDto } from "../../../../dtos/PhaseDto";

type AppLike = {
    showLoadPanel: () => void;
    hideLoadPanel: () => void;
    errorToast: (message: string) => void;
};

// Whether the task's header offers Download All (template setting; never in templates mode).
export const showsDownloadAll = (phase?: PhaseDto | null): boolean =>
    phase?.defaultPhase?.settings?.showDownloadAll === true;

// Downloads every file in the phase as one zip, saving it through a temporary link.
export async function downloadPhaseFiles(app: AppLike, phaseId: string, module: Modules): Promise<void> {
    app.showLoadPanel();
    const result = await getPhaseFiles(phaseId, module);
    if (result?.error) {
        app.errorToast(result.error.message);
    } else if (result?.data?.blob) {
        const link = document.createElement("a");
        const url = URL.createObjectURL(result.data.blob);
        link.href = url;
        link.download = result.data.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } else {
        app.errorToast("Failed to download phase files");
    }
    app.hideLoadPanel();
}
